'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef, useContext } from 'react';
import { Button } from '../button/button.js';
import { Context } from './dialog-trigger-context.js';

/**
 * DialogTrigger component, used within a Dialog.TriggerContext to open a dialog.
 *
 * @example
 * <Dialog.TriggerContext>
 *   <Dialog.Trigger>Open Dialog</Dialog.Trigger>
 *   <Dialog>
 *     Content
 *   </Dialog>
 * </Dialog.TriggerContext>
 */
const DialogTrigger = forwardRef(function DialogTrigger({ asChild, ...rest }, ref) {
    const { id, modal } = useContext(Context);
    const Component = asChild ? Slot : Button;
    return (jsx(Component, { suppressHydrationWarning // Might get augmented through designsystemet-web with aria-haspopup
        : true, command: modal ? 'show-modal' : '--show-non-modal', commandfor: id, ref: ref, ...rest }));
});

export { DialogTrigger };
